import type { RecalculateRiskScoresMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { RecalculateRiskScoresDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

/**
 * recalculateRiskScores (RSP-6156) — a no-input trigger. On the tRPC path the
 * mutation resolves once the async request completes (the data-layer emits the
 * trigger, event-consumers recomputes, and the RiskScoresRecalculated
 * completion event closes the request-state-api request).
 */
export const useRecalculateRiskScores = createMutationHook({
  name: 'recalculateRiskScores',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.aggregation.recalculateRiskScores.mutationOptions({
      onSuccess,
    }),
  mapInput: (_input: void) => undefined,
  // COI-889: safe to invalidate — `executeAsyncRequest` polls until the
  // RiskScoresRecalculated completion event lands, so the rows exist here.
  invalidate: (trpc) => [trpc.frontend.risk.pathKey()],
  // Consumers ignore the payload — the recomputed scores are read back.
  mapResponse: (): RecalculateRiskScoresMutation => ({
    recalculateRiskScores: {
      __typename: 'RecalculateRiskScoresOutput',
      message: null,
    },
  }),
  graphqlDocument: RecalculateRiskScoresDocument,
  graphqlVariables: () => ({}),
});
